// import Auth from '../../../utils/auth';
// import Util from '../../../utils/util';
// import Global from '../../../utils/global';

import {
  getLocalAddr,
  getOutOfDateTimeApi,
  heartbeatApi,
  downloadHistApi
} from '../../service/person.js';
import { logoutApi } from '../../service/login.js';


export default {
  props: {
    mode: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    percentage: {
      type: Number,
      default: 0
    },
    customize: {
      type: Object,
      default() {
        return {
          diffTimeStamp: 0,
          hideTheme: false,
          hideDownload: false,
          hideSetting: false,
          hideLogout: false,
          hideLocalAddr: false,
          disableDownloadLog: false,
          enableMediaDownload: false,
          heartbeat: false,
          hideExpireTime: false
        };
      }
    }
  },
  data() {
    return {
      sessionWarningDialg: false,
      sessionWarningTips: '您已长时间未操作，即将强制退出',
      outOfDateTime: '',
      localAddr: '',
      wsConnectErrorCount: 0,
      userinfo: {},
      popoverShow: false,
      currentdate: '',
      timeInterval: null,
      timeIntervalSessionExpired: null,
      kickUserSubscribe: null,
      kickOnlineUserSubscribe: null,
      onlineNumberSubscribe: null,
      hasCreatedStompClient: false
    };
  },
  computed: {
    isVue3(){
      return this.$global.isVue3();
    },
    logoutIconTips() {
      if (this.$global.isAppPortalWebview()) {
        return '关闭应用';
      } else {
        return '退出登录';
      }
    },
    downloadState() {
      return this.$store.state.kiaf.personCenter.downloadState;
    }
  },
  mounted() {
    if (this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']) {
      localStorage.setItem(
        this.$constants.STORAGE_KEY_LAST_MOUSEMOVE_TIME,
        new Date().getTime()
      );
      document.addEventListener('mousemove', this.handleMouseMove);
    }
    if (
      !this.timeIntervalSessionExpired &&
      this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']
    ) {
      this.timeIntervalSessionExpired = setInterval(() => {
        this.checkSession();
      }, 10000);
    }
  },
  beforeDestroy() {
    if (this.onlineNumberSubscribe) {
      this.onlineNumberSubscribe.unsubscribe();
    }
    if (this.kickUserSubscribe) {
      this.kickUserSubscribe.unsubscribe();
    }
    if (this.kickOnlineUserSubscribe) {
      this.kickOnlineUserSubscribe.unsubscribe();
    }
    this.timeInterval && clearInterval(this.timeInterval);
    this.timeIntervalSessionExpired &&
    clearInterval(this.timeIntervalSessionExpired);
    document.removeEventListener('mousemove', this.handleMouseMove);
    // 清理正在下载的ws链接
    this.hasCreatedStompClient && this.$util.disconnectSocketClient(this.$util.getSocketClient(''));
  },
  watch: {
    downloadState(newVal, oldVal) {
      this.downloadShowChanged = true;
      if (newVal) {
        this.downloadShow = true;
      } else {
        this.downloadShow = false;
      }
    },
    personalShow(newVal, oldVal) {
      if (newVal) {
        this.timeInterval = setInterval(() => {
          this.timeFormat();
        }, 1000);
      } else {
        clearInterval(this.timeInterval);
      }
      this.checkPopoverShow();
    },
    downloadShow() {
      this.checkPopoverShow();
    }
  },
  created() {
    this.init();
    if(!this.customize.hideExpireTime){
      this.getOutOfDateTime();
    }

    if (!this.$util.isWindowMap()) {
      if (this.customize.heartbeat) {
        this.keepHeartbeat();
      }
      this.$onMessage(
        this.$constants.EVENT_BUS_CODE_START_HEARTBEAT,
        (msg) => {
          if (!this.customize.heartbeat) {
            this.customize.heartbeat = true;
            this.keepHeartbeat();
          }
        },
        this
      );
      this.$onMessage(
        this.$constants.EVENT_BUS_CODE_STOP_HEARTBEAT,
        (msg) => {
          this.customize.heartbeat = false;
        },
        this
      );
    }
    this.$onMessage(
      this.$constants.EVENT_BUS_CODE_APP_CLOSED_APP,
      (msg) => {
        setTimeout(() => {
          this.$util.closeAllWindow();
        }, 1000);
      },
      this
    );
    this.$onMessage(this.$constants.EVENT_BUS_CODE_KEEP_SESSION_ACTIVE, () => {
      this.sessionWarningDialg = false;
    });
  },
  methods: {
    keepSessionActive() {
      this.$postMessage(this.$constants.EVENT_BUS_CODE_KEEP_SESSION_ACTIVE, {});
    },
    checkSession() {
      let ipWhitelist = this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']['ip_whitelist'];
      if (ipWhitelist && ipWhitelist.indexOf(this.localAddr) >= 0) {
        clearInterval(this.timeIntervalSessionExpired);
        document.removeEventListener('mousemove', this.handleMouseMove);
        return;
      }
      let lastActionTime = localStorage.getItem(
        this.$constants.STORAGE_KEY_LAST_MOUSEMOVE_TIME
      );
      let nowTime = new Date().getTime();
      let warningTime = this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']['warning'];
      let expiredTime = this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']['expired'];
      let seconds = parseInt((nowTime - lastActionTime) / 1000);
      if (seconds >= expiredTime) {
        this.logOutAction();
      } else if ((nowTime - lastActionTime) / 1000 > warningTime) {
        let duration = parseInt(expiredTime - seconds);
        let mm = parseInt(duration / 60) + (duration % 60 > 0 ? 1 : 0);
        let message =
          this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE']['tips'] ||
          '您已长时间未操作，#time#分钟后将强制退出';
        this.sessionWarningTips = message.replace('#time#', mm);
        this.sessionWarningDialg = true;
      } else {
        this.sessionWarningDialg = false;
      }
    },
    handleMouseMove(e) {
      if (
        this.$global.getCustomConfig()['KIAF_SESSION_EXPIRED_RULE'] &&
        !this.sessionWarningDialg
      ) {
        localStorage.setItem(
          this.$constants.STORAGE_KEY_LAST_MOUSEMOVE_TIME,
          new Date().getTime()
        );
      }
    },
    checkPopoverShow() {
      if (this.personalShow || this.downloadShow) {
        this.popoverShow = true;
      }
      if (!this.personalShow && !this.downloadShow) {
        this.popoverShow = false;
      }
    },
    getUserRole(index) {
      let roles = this.userinfo.roles;
      if (index < 0) {
        let result = '<p><b>用户角色：</b></p>';
        roles.forEach((role) => {
          result += '<p>' + role.name + '</p>';
        });
        return result;
        // 多行信息<br/>第二行信息
      } else if (roles && index < roles.length) {
        return roles[index].name;
      }
      return '';
    },
    avatarTitle() {
      let arr = this.customize.avatarMode.split('&');
      let result = '';
      for (let i = 0; i < arr.length; i++) {
        if (i == 0) {
          result = this.userinfo[arr[i]];
        } else {
          result += ' ' + this.userinfo[arr[i]];
        }
      }
      return result;
    },
    isEllipsis(str, maxLen) {
      let len = this.$util.calcLength(str);
      return len >= maxLen;
    },
    keepHeartbeat() {
      if (this.customize.heartbeat) {
        if (
          this.$global.getHeartBeatTriggers() &&
          this.$global.getHeartBeatTriggers().length > 0
        ) {
          let params = {
            username: this.$auth.getUserInfo()['username'],
            jwtToken: this.$auth.getJwtToken(),
            triggers: this.$global.getHeartBeatTriggers()
          };
          heartbeatApi(params);
        }
        setTimeout(() => {
          this.keepHeartbeat();
        }, 10000);
      }
    },
    showPersonCenter(e) {
      e.stopPropagation();
      this.downloadShow = false;
      this.personalShow = true;
      this.$nextTick(this.triggerResize);
    },
    showDownloadCenter() {
      // this.personalShow = true;
    },
    updateHomePage(val) {
      this.personalShow = false;
      this.$emit('updateHomePage', val);
    },
    async init() {
      if (this.$global.getCustomConfig()['CAS_SINGLE_CLIENT'] === 'Y') {
        this.customize.kickOnlineUser = true;
      }
      // if (!this.customize.avatar) {
      //   this.customize.avatar = this.customize.isometric ? require('../../../theme/src/images/user.png') : require('../../../theme/src/images/police.png');
      // }
      // let user = await this.$auth.getUser();
      let userTask = this.$auth.getUser();
      let user = await userTask;
      if (user && user.id) {
        this.userinfo = user;
      }
      let addrResult = '';
      if (
        this.$global.getCustomConfig()['KIAF_ONLINE_NUMBER'] === 'Y' ||
        !this.customize.hideLocalAddr
      ) {
        addrResult = await getLocalAddr({});
        if (addrResult != null && typeof addrResult === 'string') {
          this.localAddr = addrResult;
        }
      }
      if (user && user.id) {
        // 页面渲染后即建立 websocket 连接
        if (
          (!this.customize.disableDownloadLog &&
            !this.customize.hideDownload) ||
          this.customize.kickOnlineUser
        ) {
          // this.createWebsocket(this.userinfo.username);
          this.createWebsocket(addrResult);
        }
      }
      // if (!this.customize.hideLocalAddr) {
      //   // let addrResult = await getLocalAddr({});
      //   if (addrResult != null && typeof addrResult === 'string') {
      //     this.localAddr = addrResult;
      //   }
      // }
      if (!this.customize.disableDownloadHist && !this.customize.hideDownload) {
        let items = await downloadHistApi();
        if (Array.isArray(items)) {
          items.forEach((item) => {
            if (!item.id && item.completeId) {
              item.id = item.completeId;
            }
            this.downloadList.push(item);
          });
        }
      }
    },
    getOutOfDateTime() {
      getOutOfDateTimeApi({}).then((result) => {
        if (result && result.code === '4018') {
          this.outOfDateTime = result.message;
        } else {
          this.outOfDateTime = '';
        }
      });
    },
    createWebsocket(addr) {
      let username = this.userinfo.username;
      let stompClient = this.$util.getSocketClient('');
      this.hasCreatedStompClient = true;
      let clientId = username;
      if (
        addr &&
        this.$global.getCustomConfig()['KIAF_ONLINE_NUMBER'] === 'Y'
      ) {
        clientId = `kiafOnline|${username}|${addr}`;
      }
      let connectInfo = {
        usreId: username,
        onDisconnectTopic: '/user',
        clientId: clientId
      };
      if (stompClient) {
        stompClient.connect(
          connectInfo,
          (frame) => {
            console.warn(frame, '建立一个websocket');
            this.websocketOnmsg(stompClient);
          },
          (error) => {
            console.error('websocet 连接失败>>>', error);
            this.$util.disconnectSocketClient(stompClient);
            let duration = 3000;
            setTimeout(() => {
              this.createWebsocket(addr);
            }, duration);
          }
        );
      }
    },
    websocketOnmsg(stompClient) {
      // 此处只用于显示下载列表
      if (stompClient) {
        let username = this.userinfo.username;
        if (this.customize.kickOnlineUser) {
          this.kickUserSubscribe = stompClient.subscribe(
            '/kickUser',
            (data) => {
              let msg = JSON.parse(data.body);
              if (!msg.isKick || !msg.bcMessage) {
                return;
              } // 无效消息直接结束
              const bcMessage = JSON.parse(msg.bcMessage);
              if (
                bcMessage.action === 'kick-client' &&
                this.$global.getCustomConfig()['CAS_SINGLE_CLIENT'] === 'Y' &&
                msg.user == username &&
                bcMessage.kickType === 'jwt' &&
                bcMessage.jwtToken !== this.$auth.getJwtToken()
              ) {
                // 一个账号一个登陆点逻辑
                let alertMsg =
                  bcMessage.alert ||
                  this.$global.getCustomConfig()['KIAF_KICK_USER_MESSAGE'] ||
                  '';
                if (alertMsg) {
                  this.$alert(alertMsg, '提示', {
                    confirmButtonText: '确定',
                    callback: (action) => {
                      this.logOutAction();
                    }
                  });
                } else {
                  this.logOutAction();
                }
              }
            }
          );
          this.kickOnlineUserSubscribe = stompClient.subscribe(
            `/user/${username}/kickUser`,
            (data) => {
              let msg = JSON.parse(data.body);
              if (msg.isKick && msg.user == username) {
                let message = msg.time <= 30 ? '您的账户已被管理员锁定，请' + msg.time + '分钟后重新登录' : '您的账户已被管理员锁定，请联系管理员重新激活';
                this.$alert(message, '警告', {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.$auth.exit();
                  }
                });
              }
            }
          );
        }

        // 监听文件下载消息
        this.websocketOnmsgDownload(stompClient, username);
        // if (
        //   !this.customize.disableDownloadLog &&
        //   !this.customize.hideDownload
        // ) {
        //   this.downloadInfoSubscribe = stompClient.subscribe(
        //     `/user/${username}/downloadInfo`,
        //     (data) => {
        //       try {
        //         let msg = JSON.parse(data.body);
        //         console.info('kiaf downloadInfo>>>', msg);
        //         if (msg && Array.isArray(msg.result)) {
        //           msg.result.forEach((item) => {
        //             let found = false;
        //             // 如果当前下载任务的开始信息不在 leftTimeMap 中，添加一个对应的空对象
        //             if (!this.leftTimeMap[item.taskId]) {
        //               this.leftTimeMap[item.taskId] = {};
        //             }

        //             // 在 downloadList 中查找是否存在对应的下载信息（对比 taskId）
        //             for (let i = 0; i < this.downloadList.length; i++) {
        //               let prevItem = this.downloadList[i];
        //               // downloadList 中存在对应的信息，进行更新
        //               if (item.taskId && prevItem.taskId === item.taskId) {
        //                 for (let key in item) {
        //                   prevItem[key] = item[key];
        //                 }
        //                 // 更新标记
        //                 found = true;
        //               }
        //             }
        //             let percentNum = item.percentage.toString().split('%')[0]; // 获取当前进度
        //             if (!isNaN(percentNum)) {
        //               percentNum = Number(percentNum);
        //               if (!found && item.taskId && percentNum > 0) {
        //                 // 若 item 不存在于 downloadList 中，将其添加
        //                 this.downloadList.unshift(item);
        //                 this.lookDownload(); // 显示下载进度组件
        //               }
        //               // 遍历 downloadList，找出当前 item 对应的数据，计算当前 item 的剩余时间，并更新信息
        //               for (let i = 0; i < this.downloadList.length; i++) {
        //                 let prevItem = this.downloadList[i];
        //                 if (item.taskId && prevItem.taskId === item.taskId) {
        //                   // leftTimeMap 中没有对应的 startTime 时，表示是新的任务
        //                   // 设置它的 startTime、lastTime
        //                   if (!this.leftTimeMap[item.taskId].startTime) {
        //                     // 记录开始时间（优先使用返回数据中的 beginTime）
        //                     if (item.beginTime && !!new Date(item.beginTime)) {
        //                       this.leftTimeMap[item.taskId].startTime = new Date(item.beginTime).getTime();

        //                       // 计算剩余时间（进度大于0 且 当前时间大于开始时间）
        //                       let now = Date.now();
        //                       if (percentNum > 0 && now > this.leftTimeMap[item.taskId].startTime) {
        //                         let leftTime = (100 - percentNum) / (percentNum / ((now - this.leftTimeMap[item.taskId].startTime) / 1000));
        //                         let hh = parseInt(leftTime / 3600);
        //                         let mm = parseInt((leftTime - hh * 3600) / 60);
        //                         let ss = Math.ceil(leftTime - hh * 3600 - mm * 60);
        //                         let leftTimeFormat = Math.ceil(leftTime) > 0 ? '剩余: ' + (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '') + ss + '秒' : '';

        //                         prevItem.percentage = Number(percentNum);
        //                         prevItem.statusDesc = leftTimeFormat;
        //                       }
        //                     } else {
        //                       // beginTime 不存在时，获取当前时间做为 startTime
        //                       this.leftTimeMap[item.taskId].startTime = new Date().getTime();
        //                     }
        //                     this.leftTimeMap[item.taskId].lastTime = new Date().getTime();
        //                     break;
        //                   }
        //                   // 进度已经完成 或 status 已经变成 Y 的，修改状态，本次循环跳过
        //                   // downloadInfo 消息中，会存在 percentage 不为 100，但 status 已经变为 Y 的情况
        //                   if (item.status === 'Y' || percentNum >= 100) {
        //                     percentNum = 100;
        //                     this.leftTimeMap[item.taskId].percentageCompleted = true;
        //                     // 更新 downloadList 中对应的信息
        //                     prevItem.percentage = Number(percentNum);
        //                     prevItem.statusDesc = '';
        //                     prevItem.status = 'Y';
        //                     break;
        //                   } else if (new Date().getTime() - this.leftTimeMap[item.taskId].lastTime < 2000) {
        //                     //防止倒计时频繁抖动
        //                     break;
        //                   }

        //                   // 计算剩余时间
        //                   let now = Date.now();
        //                   if (percentNum > 0 && now > this.leftTimeMap[item.taskId].startTime) {
        //                     this.leftTimeMap[item.taskId].lastTime = new Date().getTime();
        //                     let leftTime = (100 - percentNum) / (percentNum / ((now - this.leftTimeMap[item.taskId].startTime) / 1000));
        //                     let hh = parseInt(leftTime / 3600);
        //                     let mm = parseInt((leftTime - hh * 3600) / 60);
        //                     let ss = Math.ceil(leftTime - hh * 3600 - mm * 60);
        //                     let leftTimeFormat = Math.ceil(leftTime) > 0 ? '剩余: ' + (hh > 0 ? hh + '小时' : '') + (mm > 0 ? mm + '分钟' : '') + ss + '秒' : '';
        //                     // 更新 downloadList 中的数据
        //                     prevItem.percentage = Number(percentNum);
        //                     prevItem.statusDesc = leftTimeFormat;
        //                   }
        //                 }
        //               }
        //             }
        //           });
        //         }
        //         // this.downloadList = msg.result;
        //       } catch (e) {
        //         console.error('kiaf downloadInfo>>>', e);
        //       }
        //     }
        //   );
        //   // 此处只用于下载
        //   this.downloadCompleteSubscribe = stompClient.subscribe(
        //     `/user/${username}/downloadComplete`,
        //     (data) => {
        //       let downloadInfo = JSON.parse(data.body).result;
        //       console.info('kiaf downloadComplete>>>', downloadInfo);
        //       let found = false;
        //       // 在 downloadList 列表中查找对应的下载信息 并更新对应的数据
        //       for (let i = 0; i < this.downloadList.length; i++) {
        //         let prevItem = this.downloadList[i];
        //         if (downloadInfo.taskId && prevItem.taskId === downloadInfo.taskId) {
        //           for (let key in downloadInfo) {
        //             prevItem[key] = downloadInfo[key];
        //           }
        //           prevItem.statusDesc = ''; // 清除剩余时间信息
        //           found = true;
        //           this.leftTimeMap[downloadInfo.taskId].downloadCompleted = true;
        //         }
        //       }

        //       // 返回的下载任务不在downloadList中 且 downloadInfo中有taskId，添加该数据
        //       if (!found && downloadInfo.taskId) {
        //         this.downloadList.unshift(downloadInfo);
        //       }
        //       let result = this.$util.isFileDownloadedBefore(downloadInfo);
        //       if (!result) {
        //         if (
        //           downloadInfo.downloadUrl &&
        //           downloadInfo.downloadStatus == 'READY' &&
        //           !this.$util.isWindowMap()
        //         ) {
        //           let config = {
        //             fileName: downloadInfo.zipFileName
        //           };
        //           this.$util.downloadFile(downloadInfo.downloadUrl, config);
        //         }
        //         this.$util.addDownloadedFiles(downloadInfo);
        //       }
        //     }
        //   );
        // }
        if (this.$global.getCustomConfig()['KIAF_ONLINE_NUMBER'] === 'Y' && !this.$util.isWindowMap()) {
          this.onlineNumberSubscribe = stompClient.subscribe('/onlineNumber', data => {
            this.$postMessage(this.$constants.EVENT_BUS_CODE_ONLINENUMBER, { action: 'notice-onlineNumber', message: data.body });
          });
        }
      }
    },
    intFormat(nub) {
      if (nub >= 0 && nub <= 9) {
        return '0' + nub;
      } else {
        return nub;
      }
    },
    timeFormat() {
      let timeStamp =
        new Date().getTime() + (this.customize.diffTimeStamp || 0);
      let date = new Date(timeStamp);
      let seperator1 = '-';
      let seperator2 = ':';
      let Y = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      let H = date.getHours();
      let M = date.getMinutes();
      let S = date.getSeconds();
      this.currentdate =
        Y +
        seperator1 +
        this.intFormat(month) +
        seperator1 +
        this.intFormat(strDate) +
        ' ' +
        this.intFormat(H) +
        seperator2 +
        this.intFormat(M) +
        seperator2 +
        this.intFormat(S);
    },
    checkPersonal(e) {
      e.stopPropagation();
      this.downloadShow = false;
      this.personalShow = !this.personalShow;
      this.$nextTick(this.triggerResize);
    },
    // 退出登录
    logOut(tips = '', confirmButtonText = '确定', cancelButtonText = '取消') {
      tips = tips || this.logoutIconTips;
      this.$confirm('确定要' + tips + '吗？', '提示', {
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        type: 'warning'
      })
        .then(() => {
          if (
            this.customize.hookLogout &&
            typeof this.customize.hookLogout === 'function'
          ) {
            try {
              const promise = this.customize.hookLogout();
              // Promise/async函数
              if (promise.then) {
                promise.then((res) => {
                  if (res !== false) {
                    this.logOutAction();
                  }
                });
                return;
              }
              // 普通函数函数
              if (promise !== false) {
                this.logOutAction();
              }
            } catch (err) {
              this.logOutAction();
            }
            return;
          }
          this.logOutAction();
        })
        .catch((e) => {});
    },
    logOutAction() {
      let redirectUrl = this.$auth.getRedirectUrl();
      sessionStorage.setItem(this.$constants.STORAGE_KEY_REDIRECT_URL + '_' + this.$auth.getUserInfo().username, redirectUrl);
      logoutApi().then((res) => {});
      setTimeout(() => {
        //不管Api有没有请求成功，300毫秒后自动清除jwtoken退出
        this.$auth.offline();
        this.$auth.exit();
      }, 300);
    }
  }
};
